import React, { useState } from "react";
import { Form } from "react-bootstrap";
import SelectDropdown from "../dropdown";
import CustomButton from "../button";

const ProductForm = ({ formData, handleChange, handleDropdownChange, handleSubmit }) => {
  const [errors, setErrors] = useState({});

  const dropdownOptions = [
    { value: "delivered", label: "Delivered" },
    { value: "rescheduled", label: "Rescheduled" },
    { value: "cancelled", label: "Cancelled" },
  ];

  const validateForm = () => {
    const newErrors = {};
    if (!formData.status) newErrors.status = "Status is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) handleSubmit(e);
  };

  return (
    <Form onSubmit={handleFormSubmit}>
      {/* Dropdown for Status */}
      <SelectDropdown
        controlId="status"
        label="Status"
        options={dropdownOptions}
        value={formData.status}
        onChange={handleDropdownChange}
      />
      {errors.status && <small className="text-danger">{errors.status}</small>}
      <br />

      {/* Date Input */}
      <Form.Group controlId="rescheduleDate" className="mb-4">
        <Form.Label>Reschedule Date</Form.Label>
        <Form.Control
          type="date"
          name="rescheduleDate"
          value={formData.rescheduleDate}
          onChange={handleChange}
          disabled={formData.status !== "rescheduled"}
        />
        {errors.rescheduleDate && (
          <small className="text-danger">{errors.rescheduleDate}</small>
        )}
      </Form.Group>
      <br />

      {/* Submit Button */}
      <div className="d-flex justify-content-end">
        <CustomButton className="w-25 py-2" variant="primary" type="submit">
          Save
        </CustomButton>
      </div>
    </Form>
  );
};

export default ProductForm;
